import React, { useState, useEffect, useRef } from "react";
import '../components/Navbar.css';
import { FaBell } from 'react-icons/fa';
import { Link } from "react-router-dom";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navbarRef = useRef(null);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav className="navbar" ref={navbarRef}>
      <div className="bell-container">
        <FaBell style={{ color: "#4285F4", fontSize: "24px" }} />
        <span className="bell-text" style={{ color: "black" }}>NeverMissADose</span>
      </div>

      <div className={`nav-links ${menuOpen ? "active" : ""}`}>
        <a href="#features" onClick={closeMenu}>Features</a>
        <a href="#howitworks" onClick={closeMenu}>How It Works</a>
        <a href="#download" onClick={closeMenu}>Download</a>
      </div>

      <div className="hamburger" onClick={toggleMenu}>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>

      
    </nav>
  );
};

export default Navbar;





// import React, { useState } from "react";
// import { Link } from "react-router-dom"; // Import Link for routing
// import '../components/Navbar.css'; // Import CSS for Navbar styling
// import { FaBell } from 'react-icons/fa';

// const Navbar = () => {
//   const [menuOpen, setMenuOpen] = useState(false);

//   const toggleMenu = () => {
//     setMenuOpen(!menuOpen);
//   };

//   return (
//     <nav className="navbar">
//       <div className="bell-container">
//         <FaBell style={{ color: "#4285F4", fontSize: "24px" }} />  {/* Blue bell icon */}
//         <span className="bell-text" style={{ color: "black" }}>NeverMissADose</span> {/* Text next to the bell */}
//       </div>

//       {/* Links for navigation */}
//       <div className={`nav-links ${menuOpen ? "active" : ""}`}>
//         <Link to="/">Home</Link>  {/* Link to HomePage */}
//         <Link to="/features">Features</Link>  {/* Link to Hero page */}
//         <Link to="/working">How It Works</Link>  {/* Link to About page */}
//         <Link to="/download">Download</Link>  {/* Link to Footer page */}
//       </div>

//       {/* Hamburger menu */}
//       <div className="hamburger" onClick={toggleMenu}>
//         <div className="line"></div>
//         <div className="line"></div>
//         <div className="line"></div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;
